const services = [
  {
    icon: 'ri-heart-line',
    title: 'Weddings',
    desc: 'Your wedding day deserves a flawless soundtrack. From the first dance to the last song, we create the perfect atmosphere for your most memorable moments.',
    tag: 'Most Popular',
    img: 'https://static.wixstatic.com/media/c5e5c0_958d7b129e674ce0a5124044084b0069~mv2.jpg/v1/crop/x_431,y_0,w_415,h_415/fill/w_280,h_280,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Working-Timeline_00_06_06_10_Still003-2-1024x480%202.jpg',
    size: 'featured',
  },
  {
    icon: 'ri-building-line',
    title: 'Corporate Events',
    desc: 'Professional DJ and entertainment services for company parties, galas, product launches, and team events — keeping your guests engaged all night.',
    tag: 'Professional',
    img: 'https://static.wixstatic.com/media/c5e5c0_59f5d4a60c76414080103c5584bc0290~mv2.jpg/v1/crop/x_58,y_0,w_1541,h_1194/fill/w_280,h_280,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/c5e5c0_59f5d4a60c76414080103c5584bc0290~mv2.jpg',
    size: 'tall',
  },
  {
    icon: 'ri-graduation-cap-line',
    title: 'Schools',
    desc: 'Prom nights, homecomings, and school dances done right. High-energy DJ sets and emcee services that keep students on the dance floor all night long.',
    tag: 'High Energy',
    img: 'https://static.wixstatic.com/media/c5e5c0_8919903d97924dde82a68c787ed21882~mv2.jpg/v1/crop/x_90,y_0,w_540,h_540/fill/w_280,h_280,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG_0478.jpg',
    size: 'normal-dark',
  },
  {
    icon: 'ri-gamepad-line',
    title: 'Game Shows',
    desc: 'Interactive live game show experiences that get your guests competing, laughing, and talking about your event for years to come.',
    tag: 'Interactive',
    img: 'https://static.wixstatic.com/media/c5e5c0_16294f2462cf437b81a92051b9102bb5~mv2.jpg/v1/crop/x_63,y_0,w_253,h_380/fill/w_280,h_280,al_c,lg_1,q_80,enc_avif,quality_auto/c5e5c0_16294f2462cf437b81a92051b9102bb5~mv2.jpg',
    size: 'normal-img',
  },
  {
    icon: 'ri-camera-line',
    title: 'Photo Booths',
    desc: 'Fun, branded photo booth experiences with instant prints and digital sharing. The perfect keepsake for weddings, corporate events, and parties.',
    tag: 'Fan Favorite',
    img: 'https://static.wixstatic.com/media/c5e5c0_a66abf94b3a74b20a427926b19b2b19a~mv2_d_3456_5184_s_4_2.jpg/v1/fill/w_291,h_291,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/c5e5c0_a66abf94b3a74b20a427926b19b2b19a~mv2_d_3456_5184_s_4_2.jpg',
    size: 'wide',
  },
  {
    icon: 'ri-mic-line',
    title: 'Karaoke',
    desc: 'Professional karaoke setups for private parties, corporate events, and bars. Thousands of songs, great sound, and an emcee to keep the energy high.',
    tag: 'Party Starter',
    img: 'https://static.wixstatic.com/media/c5e5c0_63920ccb427f43618e89f8e212a36211~mv2.jpg/v1/crop/x_663,y_39,w_409,h_616/fill/w_280,h_280,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/c5e5c0_63920ccb427f43618e89f8e212a36211~mv2.jpg',
    size: 'tall',
  },
];

export default function ServicesSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="bg-[#080808] py-28 md:py-36 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_0%,_#D4AF3706_0%,_transparent_70%)] pointer-events-none"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-px bg-[#D4AF37]"></div>
              <span className="text-[#D4AF37] text-xs tracking-[0.35em] uppercase font-semibold">What We Do</span>
            </div>
            <h2
              className="text-4xl md:text-5xl font-black text-white leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Full-Service<br />
              <em className="text-[#D4AF37] not-italic">DJ &amp; Entertainment</em>
            </h2>
          </div>
          <p className="text-gray-500 text-base leading-relaxed max-w-sm lg:text-right">
            From weddings and corporate events to school dances and private parties — Bugsie Productions delivers premium DJ, emcee, and entertainment services across the Seattle &amp; Puget Sound region.
          </p>
        </div>

        {/* ── BENTO GRID ── */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-14">

          {/* 1 — FEATURED: Weddings (spans 2 cols) */}
          <div className="group relative lg:col-span-2 rounded-2xl overflow-hidden cursor-default h-[340px]">
            <img
              src={services[0].img}
              alt="Wedding DJ services by Bugsie Productions"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>
            <div className="absolute top-5 left-5 bg-[#D4AF37] text-black text-[10px] tracking-widest uppercase font-bold px-3 py-1 rounded-full whitespace-nowrap">
              {services[0].tag}
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-7">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-[#D4AF37]/15 border border-[#D4AF37]/30">
                  <i className={`${services[0].icon} text-[#D4AF37] text-base`}></i>
                </div>
                <h3 className="text-white font-black text-xl" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {services[0].title}
                </h3>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed max-w-lg">{services[0].desc}</p>
            </div>
            <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/0 to-transparent group-hover:via-[#D4AF37]/50 transition-all duration-500"></div>
          </div>

          {/* 2 — TALL: Corporate (spans 2 rows) */}
          <div className="group relative rounded-2xl overflow-hidden cursor-default md:row-span-2 h-[340px] md:h-auto">
            <img
              src={services[1].img}
              alt="Corporate event DJ services by Bugsie Productions"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent"></div>
            <div className="absolute top-5 right-5 bg-black/60 backdrop-blur-sm border border-[#D4AF37]/40 text-[#D4AF37] text-[10px] tracking-widest uppercase font-semibold px-3 py-1 rounded-full whitespace-nowrap">
              {services[1].tag}
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-[#D4AF37]/15 border border-[#D4AF37]/30 mb-3">
                <i className={`${services[1].icon} text-[#D4AF37] text-base`}></i>
              </div>
              <h3 className="text-white font-black text-lg mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                {services[1].title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">{services[1].desc}</p>
            </div>
          </div>

          {/* 3 — DARK BG (no image): Schools */}
          <div className="group relative bg-[#0F0F0F] border border-white/6 rounded-2xl overflow-hidden cursor-default hover:border-[#D4AF37]/30 transition-all duration-500 h-[200px] flex flex-col justify-between p-6">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_60%_at_80%_20%,_#D4AF3708_0%,_transparent_70%)] pointer-events-none"></div>
            <div className="relative z-10">
              <div className="flex items-center justify-between mb-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/25">
                  <i className={`${services[2].icon} text-[#D4AF37] text-lg`}></i>
                </div>
                <span className="text-[#D4AF37]/60 text-[10px] tracking-widest uppercase font-semibold whitespace-nowrap">{services[2].tag}</span>
              </div>
              <h3 className="text-white font-black text-base mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                {services[2].title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed">{services[2].desc}</p>
            </div>
            <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/0 to-transparent group-hover:via-[#D4AF37]/40 transition-all duration-500"></div>
          </div>

          {/* 4 — COMPACT IMAGE: Game Shows */}
          <div className="group relative rounded-2xl overflow-hidden cursor-default h-[200px]">
            <img
              src={services[3].img}
              alt="Game show entertainment by Bugsie Productions"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/50 to-black/20"></div>
            <div className="absolute top-4 right-4 bg-black/60 backdrop-blur-sm border border-[#D4AF37]/30 text-[#D4AF37] text-[10px] tracking-widest uppercase font-semibold px-3 py-1 rounded-full whitespace-nowrap">
              {services[3].tag}
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <div className="flex items-center gap-2 mb-1">
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#D4AF37]/15 border border-[#D4AF37]/25">
                  <i className={`${services[3].icon} text-[#D4AF37] text-xs`}></i>
                </div>
                <h3 className="text-white font-black text-sm" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {services[3].title}
                </h3>
              </div>
              <p className="text-gray-300 text-xs leading-relaxed">{services[3].desc}</p>
            </div>
          </div>

          {/* 5 — WIDE HORIZONTAL: Photo Booths (spans 2 cols) */}
          <div className="group relative lg:col-span-2 bg-[#0F0F0F] border border-white/6 rounded-2xl overflow-hidden cursor-default hover:border-[#D4AF37]/30 transition-all duration-500 h-[220px] flex flex-col md:flex-row">
            <div className="relative md:w-2/5 h-40 md:h-full overflow-hidden flex-shrink-0">
              <img
                src={services[4].img}
                alt="Photo booth rental by Bugsie Productions"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0F0F0F] hidden md:block"></div>
              <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#0F0F0F] md:hidden"></div>
            </div>
            <div className="flex flex-col justify-center p-6 md:p-8 relative z-10">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/25">
                  <i className={`${services[4].icon} text-[#D4AF37] text-base`}></i>
                </div>
                <div>
                  <span className="text-[#D4AF37]/60 text-[10px] tracking-widest uppercase font-semibold block whitespace-nowrap">{services[4].tag}</span>
                  <h3 className="text-white font-black text-lg leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {services[4].title}
                  </h3>
                </div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed max-w-md">{services[4].desc}</p>
            </div>
            <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/0 to-transparent group-hover:via-[#D4AF37]/40 transition-all duration-500"></div>
          </div>

          {/* 6 — TALL: Karaoke */}
          <div className="group relative rounded-2xl overflow-hidden cursor-default h-[340px]">
            <img
              src={services[5].img}
              alt="Karaoke services by Bugsie Productions"
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent"></div>
            <div className="absolute top-5 left-5 bg-black/60 backdrop-blur-sm border border-[#D4AF37]/40 text-[#D4AF37] text-[10px] tracking-widest uppercase font-semibold px-3 py-1 rounded-full whitespace-nowrap">
              {services[5].tag}
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-[#D4AF37]/15 border border-[#D4AF37]/30 mb-3">
                <i className={`${services[5].icon} text-[#D4AF37] text-base`}></i>
              </div>
              <h3 className="text-white font-black text-lg mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                {services[5].title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">{services[5].desc}</p>
            </div>
          </div>

        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
            className="inline-flex items-center gap-3 bg-[#D4AF37] hover:bg-[#c49d2a] text-black font-bold px-12 py-4 rounded-full text-sm tracking-widest uppercase transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            Request a Custom Quote
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
